import { Component, OnInit } from '@angular/core';
import { AuditTrailServiceService } from './audit-trail-service/audit-trail-service.service';

import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { constants } from 'src/app/shared/common/contants';
import { DatePipe } from '@angular/common';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
//created by -Abhishek T
//21-04-2023
//to add a new screen for audit records
@Component({
    selector: 'app-audit-trail',
    templateUrl: './audit-trail.component.html',
    styleUrls: ['./audit-trail.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class AuditTrailComponent implements OnInit {
  fromDate: Date;
  toDate: Date;
  
  rowbindingdata;
  
  paginationPageSize;

  paginationNumberFormatter;

  rowClassRules;

  lastpage;

  currentpage;

  nextpage;

  nextpageplusone;

  totalpages;

  pagesize;

  getdata: any = []

  columnDefs;

  defaultColDef;

  rowSelection;

  
  backgroundColorScreen="";

  buttonColor="";

  components;
  value;
 


  constructor( private datePipe: DatePipe,private snackBar: MatSnackBar,private service:AuditTrailServiceService,private spinner: NgxUiLoaderService, private snackbar: MatSnackBar,private localStorageSettings: LocalStorageSettingsService,private constants: constants) { }

  ngOnInit(): void {
    this.columnDefs = [
      { headerName: 'CreatedBy', headerTooltip: 'CreatedBy', tooltipValueGetter: (params) => 'CreatedBy : ' + params.value, field: 'createdBy', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'CreatedAt', headerTooltip: 'CreatedAt', tooltipValueGetter: (params) => 'CreatedAt : ' + params.value, field: 'createdAt', filter: 'agTextColumnFilter', width: 250 },
	{ headerName: 'Affected ClassName', headerTooltip: 'Affected ClassName', tooltipValueGetter: (params) => 'Affected ClassName : ' + params.value, field: 'affectedClassName', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Affected RecordId', headerTooltip: 'Affected RecordId', tooltipValueGetter: (params) => 'Affected RecordId : ' + params.value, field: 'affectedRecordId', filter: 'agTextColumnFilter', width: 100 },
      { headerName: 'Modified Fields', headerTooltip: 'Modified Fields', tooltipValueGetter: (params) => 'Modified Fields : ' + params.value, field: 'modified_fields', filter: 'agTextColumnFilter', width: 450 },
      { headerName: 'Action Type', headerTooltip: 'Action Type', tooltipValueGetter: (params) => 'Action Type : ' + params.value, field: 'actionType', filter: 'agTextColumnFilter', width: 150 },
    ]
    // if the record has status==no , row color will change
    this.rowClassRules = {
      "sick": function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },

    };
    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };


    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

    this.fromDate=new Date();
    this.toDate=new Date();
  }

 //excel export function
onBtExport() {

  this.rowbindingdata.api.exportDataAsCsv({

    processCellCallback: (params) => {

      if (typeof params.value === 'string') {

        // preserve exact content
        // only remove row-breaking new lines
        return params.value.replace(/\r?\n|\r/g, ' ');
      }

      return params.value;
    },

    fileName: 'AuditTrail.csv'
  });
}

//pagination code
onPaginationChanged() {
  if (this.rowbindingdata) {
    this.lastpage = this.rowbindingdata.api.paginationIsLastPageFound();
    this.currentpage = this.rowbindingdata.api.paginationGetCurrentPage() + 1
    this.nextpage = this.rowbindingdata.api.paginationGetCurrentPage() + 1 + 1
    this.nextpageplusone = this.rowbindingdata.api.paginationGetCurrentPage() + 1 + 1 + 1
    this.totalpages = this.rowbindingdata.api.paginationGetTotalPages()
  }
}
//this function is for going to the given page number 
onSearchChange(searchValue: number) {

  this.rowbindingdata.api.paginationGoToPage(searchValue - 1);
}

// below function is for changing the no of rows per page
onPageSizeChanged(newPageSize) {
  var value = this.pagesize
  this.rowbindingdata.api.setGridOption('paginationPageSize', Number(value));
}

// below function is for going to next page
onBtNext() {
  console.log("next")
  this.rowbindingdata.api.paginationGoToNextPage();
}

// below function for going to previous page
onBtPrevious() {
  console.log("previous")
  this.rowbindingdata.api.paginationGoToPreviousPage();
}

// below function for going to first page
onBtFirst() {
  console.log("first")
  this.rowbindingdata.api.paginationGoToFirstPage();
}

// below function for going to last page
onBtLast() {
  console.log("last")
  this.rowbindingdata.api.paginationGoToLastPage();
}
//pagination code ends

onGridReady(params){
this.rowbindingdata = params;
    const today = new Date();

    const formattedToday = this.datePipe.transform(today, 'yyyy-MM-dd');
    console.log("Today's date => "+formattedToday)
this.service.retrieveauditInRange(formattedToday,formattedToday,"en").subscribe(response=>{
  this.spinner.start();
  console.log(response);
  // checking if response is true or not
  if (response.error == true) {
    this.snackbar.open(response.statusMessage, "OK", {
      duration: 5000,
    });
    this.rowbindingdata.setGridOption('rowData', [])

  } else {

   this.DataShowOnGrid(response);

  }
  this.spinner.stop();
});
}


DataShowOnGrid(response){
  console.log(response)
  this.getdata = response
  console.log(this.getdata)
  this.rowbindingdata.api.setGridOption('rowData', this.formatDates(this.getdata))
 console.log( this.formatDates(this.getdata));
}



  formatDates(objects: any): any {
    return objects.map((obj: any) => {
      const date = new Date(obj.createdAt);
      obj.createdAt = `${date.getDate()} ${this.getMonthAbbreviation(date)} ${date.getFullYear()} ${this.formatTime(date)}`;
      return obj;
    });
  }

  getMonthAbbreviation(date: Date): string {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[date.getMonth()];
  }

  formatTime(date: Date): string {
    const hour = date.getHours();
    const minute = date.getMinutes().toString().padStart(2, '0');
    const period = hour >= 12 ? 'PM' : 'AM';
    const formattedHour = (hour % 12 || 12).toString().padStart(2, '0');
    return `${formattedHour}:${minute} ${period}`;
  }
  

  collectDates() {
    if(!this.fromDate){
      this.snackBar.open(this.constants.selectFromDate, "OK", {duration: 5000});
    }
    else if (!this.toDate) {
      this.snackBar.open(this.constants.selectToDate, "OK", {duration: 5000});
    }
    else if(this.fromDate>this.toDate){
      this.snackBar.open(this.constants.toDateShouldBeGreator, "OK", {duration: 5000});
    }
    else {
      this.snackbar.open("Please Wait. The process is already running.", "OK", { duration: 10000 });
    const formattedFromDate = this.datePipe.transform(this.fromDate, 'yyyy-MM-dd');
    const formattedToDate = this.datePipe.transform(this.toDate, 'yyyy-MM-dd');

    //Do something with the selected dates
    console.log('Selected Dates:', formattedFromDate, formattedToDate);
    this.service.retrieveauditInRange(formattedFromDate,formattedToDate,"en").subscribe(response=>{
      this.spinner.start();
      console.log(response);
      // checking if response is true or not
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.rowbindingdata.setGridOption('rowData', [])
    
      } else {
    
       this.DataShowOnGrid(response);
    
      }
      this.spinner.stop();
    });
    
    

    }
  }
}









